import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaChevronRight, FaHome } from 'react-icons/fa';

const PageHeader = ({ title }) => {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter((x) => x);

  // --- LANGUAGE SYNC LOGIC ---
  const [lang, setLang] = useState(localStorage.getItem('lang') || 'en');

  useEffect(() => {
    const handleStorageChange = () => {
      setLang(localStorage.getItem('lang') || 'en');
    };
    window.addEventListener('storage', handleStorageChange);
    const interval = setInterval(handleStorageChange, 500);
    return () => {
      window.removeEventListener('storage', handleStorageChange);
      clearInterval(interval);
    };
  }, []);

  // --- TRANSLATION DICTIONARY ---
  const translations = {
    en: {
      home: "Home",
      contact: "Contact Us",
      about: "About Us",
      services: "Services",
      career: "Career",
      // Agar props se title "Services" aaye toh yahan se match karega
      "Services": "Services",
      "Contact Us": "Contact Us",
      "About Us": "About Us",
      "Career": "Career"
    },
    zh: {
      home: "首页",
      contact: "联系我们",
      about: "关于我们",
      services: "服务项目",
      career: "职业生涯",
      // Mapping static props to Chinese
      "Services": "服务项目",
      "Contact Us": "联系我们",
      "About Us": "关于我们",
      "Career": "职业生涯"
    }
  };

  // Helper function to translate titles/routes
  const getLabel = (text) => {
    if (!text) return "";
    // Title case ya lower case dono handle karne ke liye
    return translations[lang][text] || translations[lang][text.toLowerCase()] || text.replace(/-/g, ' ');
  };

  return (
  <section className="relative w-full h-[40vh] md:h-[60vh] flex items-center justify-center overflow-hidden">
  
  {/* Background Image */}
  <div 
    className="absolute inset-0 bg-fixed bg-center bg-cover"
    style={{ 
      backgroundImage: `url('./young-happy-couple-making-agreement-with-their-financial-advisor-home-men-are-shaking-hands.jpg')` 
    }}
  />
  
  {/* Overlay (using your palette) */}
  <div className="absolute inset-0 bg-[#0D1B2A]/60 backdrop-blur-[2px]" />

  {/* Content */}
  <div className="container relative z-10 max-w-4xl px-6 mx-auto text-center">
    
    <div className="flex flex-col items-center justify-center gap-6">
      
      {/* TITLE (removed dot + premium color) */}
      <h1 className="text-4xl md:text-6xl font-[Playfair_Display] tracking-tight text-[#F5F0E8]">
        {getLabel(title)}
      </h1>

      {/* BREADCRUMB */}
      <nav className="flex items-center gap-3 text-[12px] uppercase tracking-[0.25em] font-sans bg-white/5 backdrop-blur-md px-6 py-3 rounded-full border border-white/10">
        
        <Link 
          to="/" 
          className="flex items-center gap-2 text-[#999999] hover:text-[#B08D57] transition"
        >
          <FaHome size={14} />
          {translations[lang].home}
        </Link>

        {pathnames.map((name, index) => {
          const routeTo = `/${pathnames.slice(0, index + 1).join('/')}`;
          const isLast = index === pathnames.length - 1;

          return (
            <React.Fragment key={name}>
              <FaChevronRight size={10} className="text-[#999999]/40" />

              {isLast ? (
                <span className="text-[#B08D57]">
                  {getLabel(name)}
                </span>
              ) : (
                <Link 
                  to={routeTo} 
                  className="text-[#999999] hover:text-[#B08D57] transition"
                >
                  {getLabel(name)}
                </Link>
              )}
            </React.Fragment>
          );
        })}
      </nav>

    </div>
  </div>
</section>
  );
};

export default PageHeader;